<div class="confirm-modal ig-modal account-user-modal">
    <div [formGroup]="createAccountFormGroup">
        <p>{{hubName}} Users</p>
        <ig-row>
            <ig-col [xs]="12" [md]="6">
                <ig-list>
                    <div header>
                        <ig-list-column-header>
                            <ig-row>
                                <ig-col [xs]="10" [md]="5">Username</ig-col>
                                <ig-col [xs]="10" [md]="6">Create Time</ig-col>
                            </ig-row>
                        </ig-list-column-header>
                    </div>

                    <div body>
                        <ig-list-item *ngFor="let user of accountUsers">
                            <ig-row>
                                <ig-col [xs]="10" [md]="5">{{user.userName}}</ig-col>
                                <ig-col [xs]="10" [md]="6">{{user.createLocalString}}</ig-col>
                            </ig-row>
                            <ig-row-action-buttons style="max-width: 0">
                                <mat-icon matTooltip="Delete" (click)="deleteUser(user)">
                                    clear
                                </mat-icon>
                            </ig-row-action-buttons>
                        </ig-list-item>
                        <div *ngIf="!accountUsers||!accountUsers.length">No Content...</div>
                    </div>
                </ig-list>
            </ig-col>
            <ig-col [xs]="12" [md]="5" class="m-l-3">
                <h3>Create new user</h3>
                <form class="create-account-form"
                      ngForm="createAccountFormGroup"
                      autocomplete="off">
                    <ig-mat-field
                            label="User name"
                            [(ngModel)]="createAccountUserCommand.userName"
                            [formControl]="createAccountFormGroup.get('userName')">
                    </ig-mat-field>

                    <ig-mat-field label="Password"
                                  type="password"
                                  [(ngModel)]="createAccountUserCommand.password"
                                  [formControl]="createAccountFormGroup.get('password')">
                    </ig-mat-field>

                    <ig-button [isAsync]="true"
                               [disabled]="createAccountFormGroup.invalid"
                               (trigger)="createUser($event)">
                        Create
                    </ig-button>
                </form>
            </ig-col>
        </ig-row>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/account.users/account.users.modal.component.html